import { useMaterialChemistryOverrides } from "hooks/search";
import { useMaterialChemistryEdits } from "components/materialChemistry/useMaterialChemistryEdits";

export const useHandleTableMutations = () => {
  const [, setOverrides] = useMaterialChemistryOverrides();
  return useMaterialChemistryEdits(setOverrides);
};
